
export const SERVER_URL = 'http://www.ls-education.com'